export default (props = {}) => <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"{...props}>
<g id="Plus">
<path id="Vector" d="M7 1V13" stroke="#022535" stroke-width="1.32353" stroke-linecap="round" stroke-linejoin="round"/>
<path id="Vector_2" d="M13 7H1" stroke="#022535" stroke-width="1.32353" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
